import api from '../../utils/api'

export const getDashboardDataApi = () => api.get('managers/dashboard')
export const getDashboardDataAdminApi = () => api.get('admins/dashboard')
export const getDashboardDataAdminUserApi = (id) => api.get(`/admins/users/12/dashboard`)
